import { ControlConstants } from "@lib/titan2/dist/game/control/constant/ControlConstants";
import { SpineProperties } from "@lib/titan2/dist/game/control/properties/SpineProperties";
import { TextFieldProperties } from "@lib/titan2/dist/game/control/properties/TextFieldProperties";
import * as PIXI from "pixi.js";
import { GameLang } from "../lang/GameLang";
import { GameFontStyle } from "../style/GameFontStyle";
import { Modules } from "@lib/titan2/dist/game/Constants";
import { AbstractViewProperties } from "@lib/titan2/dist/game/view/properties/AbstractViewProperties";
/**
 * GameSummaryProperties.ts
 */
export class GameSummaryProperties extends AbstractViewProperties {
    constructor() {
        super();
        this.setDefaultValues();
    }
    equals(other) {
        return super.equals(other) &&
            this.totalWinTitle.equals(other.totalWinTitle);
    }
    setDefaultValues() {
        this.position.set(0, 0);
        this.panelSpineProperties = new SpineProperties("SummaryPanel", Modules.GAME);
        this.panelSpineProperties.position.set(1391, 565);
        this.title = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_TITLE, new PIXI.Point(0, -60), GameLang.RESULT, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(750, 120));
        this.totalWinTitle = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_TOTAL_WIN_TITLE, new PIXI.Point(0, -40), GameLang.TOTAL_WIN_TITLE, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(750, 80));
        this.totalWinValue = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_TOTAL_WIN_VALUE, new PIXI.Point(0, -60), null, ControlConstants.CENTER, ControlConstants.CENTER, new PIXI.Point(750, 120));
        this.slingosWinTitle = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_SLINGOS_WIN_TITLE, new PIXI.Point(20, -40), GameLang.SLINGOS, ControlConstants.LEFT, ControlConstants.CENTER, new PIXI.Point(600, 80));
        this.slingosWinValue = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_SLINGOS_WIN_VALUE, new PIXI.Point(-20, -40), null, ControlConstants.RIGHT, ControlConstants.CENTER, new PIXI.Point(750, 80));
        this.bonusWinTitle = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_BONUS_WIN_TITLE, new PIXI.Point(20, -30), GameLang.BONUS_WIN_TITLE, ControlConstants.LEFT, ControlConstants.CENTER, new PIXI.Point(250, 80));
        this.bonusWinValue = new TextFieldProperties(GameFontStyle.GAME_SUMMARY_BONUS_WIN_VALUE, new PIXI.Point(-20, -30), null, ControlConstants.RIGHT, ControlConstants.CENTER, new PIXI.Point(750, 80));
        this.gameOverTitle = new TextFieldProperties(GameFontStyle.GAME_OVER, new PIXI.Point(0, -150), GameLang.GAME_OVER, ControlConstants.CENTER, ControlConstants.TOP, new PIXI.Point(500, 400));
        this.gameOverTitle.setMultiline(true);
        this.cellTitleValuePadding = 10;
        this.totalCellWidth = 765;
    }
}
//# sourceMappingURL=GameSummaryProperties.js.map
//# sourceMappingURL=GameSummaryProperties.js.map